import { Context, useContext } from "react";
import { toast } from "react-toastify";

import { useUpdateURLSearchParams } from "@/hooks/useQuery";
import useSearchParams from "@/hooks/useSearchParams";
import { useLoadRoles } from "@/queries/profile/roles/useLoadRoles";
import useUpdateRoleById from "@/queries/profile/roles/useUpdateRoleById";
import { TeamDetails } from "@/types";
import { ZentakeContextType } from "@/types/zentake_context";
import ZentakeContext from "@/utils/ZentakeContext";

import { formatRoleDataForm, reverseFormatPermissions } from "../../utils";
import RoleForm from "./RoleForm";
import { RoleFormModel } from "./useRoleForm";

const EditRoleForm = () => {
  const searchParams = useSearchParams();
  const zentakeContext = useContext(
    ZentakeContext as unknown as Context<ZentakeContextType>,
  );
  const { data: roles, isLoading: isLoadingLoadRoles } = useLoadRoles();
  const updateParams = useUpdateURLSearchParams();
  const { updateRoleById, isLoading: isLoadingUpdateRole } =
    useUpdateRoleById();

  const teamDetails = zentakeContext?.teamDetails || ({} as TeamDetails);
  const roleId = Number(searchParams.get("editId") || 0);

  const currentRole = roles?.find((item) => item.id === roleId);

  const onFormSubmit = (data: RoleFormModel) => {
    const formattedRolePayload = formatRoleDataForm(data);

    const rest = { ...currentRole, name: undefined, permissions: undefined };

    const roleEditPayload = { ...rest, ...formattedRolePayload };

    if (!roleEditPayload.permissions.length) {
      toast.error("At least one permission is required");
      return;
    }
    updateRoleById(roleEditPayload)
      .then(() => {
        toast.success("Role updated");
        updateParams(["editId", undefined]);
      })
      .catch(() => {
        toast.error("Error updating role");
      });
  };

  const initialValues = reverseFormatPermissions(
    currentRole,
    teamDetails.assigned_submission_owner,
  );

  const isLoading = isLoadingLoadRoles || isLoadingUpdateRole;

  return (
    <RoleForm {...{ onFormSubmit, isPending: isLoading, initialValues }} />
  );
};

export default EditRoleForm;
